import { Element } from "react-scroll";
import { VideosSection } from "../../../../components";
import { WEBINAR_PAGE_CLICK_EVENT } from "../../../../Clevertap/EventNames.ts";

const EventsRecap = ({ webinarID }) => {
  return (
    <div>
      <Element name={"recorded_sessions"}>
        <VideosSection
          fetchParameters={{
            sectionId: webinarID,
            tags: [webinarID],
          }}
          pageEvent={WEBINAR_PAGE_CLICK_EVENT}
          title={"Events Recap"}
          hideViewAll={false}
          expandable
        />
      </Element>
    </div>
  );
};

export default EventsRecap;
